import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./app/store";
import App from "./App";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/font/bootstrap-icons.css";
import "./assets/css/theme.scss";
import "./assets/css/styles.css";
import "./assets/css/component.css";
import "./assets/css/custom.css";
import "./assets/css/layout.css";
import "./assets/css/service.css";
import "./assets/css/chatbot.css";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
